import React, {useState} from "react";
import {capitalizeFirstLetter} from "../../../helpers/helpers";
import Chip from "@mui/material/Chip";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";

const useDoctors = () => {

    const authState = useSelector((state) => state.authReducer);
    const roleId = authState.roleId;

    const [filters, setFilters] = useState(null);

    let navigate = useNavigate();

    const actions = {
        add: roleId !== 3 ? () => navigate("/doctores/nuevo-doctor") : false,
        edit: roleId !== 3 ? (id) => navigate(`/doctores/${id}/editar-doctor`) : false,
        delete: roleId === 1,
    };

    const renderStatusChip = (status) => {
        switch (status) {
            case 1:
                return <Chip size="small" color="secondary" label="Activa"
                             variant="outlined"/>;
            case 0:
                return <Chip size="small" color="warning" label="Inactiva"
                             variant="outlined"/>;
        }
    };

    return {
        actions, filters, setFilters, renderStatusChip
    }
};

export default useDoctors;
